import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthGuard } from '../../auth.guard';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { version } from '../../../assets/version.json';
import { UserRole } from '../../auth/roles.enum';
import { LoaderService } from '../../services/loader.service';
import { canAccessRecommendationsAudit } from '../../recommendations-audit/recommendations-audit.access';
interface RoleMenuItem extends MenuItem {
    roles?: string[];
    items?: RoleMenuItem[];
}

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule, DialogModule, ButtonModule, ToastModule],
    providers: [MessageService],
    template: `
        <div class="flex flex-col h-full">
            <p-toast></p-toast>
            <!-- Scrollable Menu -->
            <ul class="layout-menu flex flex-col flex-1 overflow-y-auto">
                <ng-container *ngFor="let item of model; let i = index">
                    <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                    <li *ngIf="item.separator" class="menu-separator"></li>
                </ng-container>

                <p-dialog [(visible)]="showLogoutDialog" appendTo="body" [style]="{ width: '350px' }" header="Logout Confirmation" [modal]="true" [closable]="false">
                    <div class="p-d-flex p-ai-center p-jc-center" style="text-align: center;">
                        <p>Are you sure you want to logout?</p>
                    </div>
                    <ng-template pTemplate="footer">
                        <button pButton label="Yes" icon="pi pi-check" (click)="confirmLogout()" class="p-button-danger"></button>
                        <button pButton label="No" icon="pi pi-times" (click)="cancelLogout()" class="p-button-secondary"></button>
                    </ng-template>
                </p-dialog>
            </ul>

            <!-- Fixed Footer -->
            <div class="p-text-center p-py-2 p-text-secondary border-top-1 surface-border">
                <a routerLink="/version-history" class="version-footer-link">
                    <small>Version {{ version }}</small>
                </a>
            </div>
        </div>
    `,
    styles: [
        `
            .layout-menu li {
                font-size: 1rem;
                font-family: inherit;
                font-weight: 500;
                color: inherit;
            }
            .layout-menu li .p-menuitem-link {
                font-size: 1.5 rem;
                font-family: inherit;
                font-weight: inherit;
                color: inherit;
            }
            .version-footer-link {
                color: inherit;
                text-decoration: none;
            }
            .version-footer-link:hover {
                text-decoration: underline;
            }
        `
    ]
})
export class AppMenu implements OnInit {
    model: RoleMenuItem[] = [];
    bottomMenu: RoleMenuItem[] = [
        {
            label: 'User Profile',
            icon: 'pi pi-user',
            routerLink: ['/view-profile']
        },
        {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: this.logout.bind(this)
        }
    ];
    // Raw roles as stored in localStorage (profile.roleGroups)
    userRoles: UserRole[] = [];
    constructor(
        public router: Router,
        private authService: AuthGuard,
        private loaderService: LoaderService,
        private messageService: MessageService
    ) {}
    version: string = '';
    ngOnInit() {
        console.log('AppMenu initialized with version:', version);
        this.version = version;
        // Get user roles from storage (same behaviour as before)
        this.userRoles = JSON.parse(localStorage.getItem('roleGroup') || '[]') as UserRole[];
        console.log('Loaded userRoles:', this.userRoles);

        // Define your menu with roles
        const fullMenu: RoleMenuItem[] = [
            {
                label: 'Home',
                items: [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'], roles: ['sales_manager_group', 'admin_group'] },
                    { label: 'User Dashboard', icon: 'pi pi-user', routerLink: ['/user-dashboard'], roles: ['sales_person_group', 'read_only_group'] },
                    ...(canAccessRecommendationsAudit()
                        ? [
                              {
                                  label: 'Recommendations dashboard',
                                  icon: 'pi pi-chart-bar',
                                  routerLink: ['/recommendations-audit'],
                                  roles: ['sales_manager_group', 'admin_group']
                              } as RoleMenuItem
                          ]
                        : []),
                    { label: 'Assign Target', icon: 'pi pi-bullseye', routerLink: ['/team-details', 1], roles: ['sales_manager_group', 'admin_group'] }
                ]
            },
            {
                label: 'User Managment',
                items: [
                    { label: 'User List ', icon: 'pi pi-users', routerLink: ['/registered-user'], roles: ['admin_group'] },
                    { label: 'Customer Portal Users', icon: 'pi pi-id-card', routerLink: ['/customer-portal-users'], roles: ['admin_group'] },
                    { label: 'Customer Support View', icon: 'pi pi-eye', routerLink: ['/customer-support'], roles: ['admin_group'] },
                    { label: 'Observability', icon: 'pi pi-chart-line', routerLink: ['/monitoring'], roles: ['admin_group'] }
                ]
            },
            {
                label: 'Order Managment',
                icon: 'pi pi-fw pi-briefcase',
                routerLink: ['/pages'],
                items: [
                    { label: 'Manage Order', icon: 'pi pi-file pi-fw', routerLink: ['/Orders1'], roles: ['sales_person_group', 'sales_manager_group', 'admin_group'] },
                    { label: 'Dispute Review', icon: 'pi pi-comments', routerLink: ['/dispute-review'], roles: ['sales_person_group', 'sales_manager_group', 'admin_group'] },
                    { label: 'Customer portal draft orders', icon: 'pi pi-file-edit', routerLink: ['/quotation-review'], roles: ['sales_person_group', 'sales_manager_group', 'admin_group'] }
                ]
            },
            {
                label: 'User Profile',
                icon: 'pi pi-fw pi-user',
                routerLink: ['/pages'],
                items: [
                    { label: 'About Torna', icon: 'pi pi-info', routerLink: ['/about-torna'], roles: ['sales_person_group', 'sales_manager_group', 'admin_group'] },
                    {
                        label: 'Version History',
                        icon: 'pi pi-history',
                        routerLink: ['/version-history'],
                        roles: ['sales_person_group', 'sales_manager_group', 'admin_group']
                    },
                    { label: 'Manage Profile', icon: 'pi pi-file pi-fw', routerLink: ['/view-profile'], roles: ['sales_person_group'] },
                    { label: 'Logout', icon: 'pi pi-times', command: this.logout.bind(this) }
                ]
            }
        ];

        console.log('Full menu before filtering:', fullMenu);

        // Filter menu items based on user roles
        this.model = this.filterMenuByRole(fullMenu, this.userRoles);

        console.log('Filtered menu:', this.model);
    }

    filterMenuByRole(menu: RoleMenuItem[], userRoles: UserRole[]): RoleMenuItem[] {
        return menu
            .map((section) => ({
                ...section,
                items: section.items
                    ? section.items.filter((item) => {
                          if (!item.roles) return true;

                          // Exclude read_only_group explicitly
                          if (item.roles.includes('read_only_group') && userRoles.includes(UserRole.ReadOnly)) {
                              return false;
                          }

                          // Allow if user has any matching role (compare by enum value)
                          return item.roles.some((role) => userRoles.includes(role as UserRole));
                      })
                    : undefined
            }))
            .filter((section) => !section.items || section.items.length > 0);
    }

    showLogoutDialog = false;

    logout() {
        if (this.blockLogoutIfBusy()) {
            return;
        }
        this.showLogoutDialog = true;
    }
    cancelLogout() {
        this.showLogoutDialog = false;
    }
    confirmLogout() {
        if (this.blockLogoutIfBusy()) {
            this.showLogoutDialog = false;
            return;
        }
        this.showLogoutDialog = false;
        this.authService.logout();
    }

    private blockLogoutIfBusy(): boolean {
        if (!this.loaderService.isAnyUiLoaderActive()) {
            return false;
        }
        this.messageService.add({
            severity: 'warn',
            summary: 'Please wait',
            detail: 'Please wait until the current operation finishes.',
            life: 3500
        });
        return true;
    }
}
